export default function (inputId: string): string {
  const id = String(inputId);
  if (id && id.length > 15 && id[id.length - 13] === '0') {
    return id.slice(0, -12).slice(0, -1) + id.slice(-12);
  }
  return id;
}
